<template>
  <div class="homeContainer">
    <head-top></head-top>
    <div class="topDiv flex-center">
      <img src="https://h5-front.leshuazf.com/juhe/images/bank-admin/top1.png" alt=""/>
    </div>
    <div class="contentWidth">
      <home-title title="解决方案"></home-title>
      <div class="resolveList flex-start">
        <resolve-item v-for="(item, index) in resolveList.filter((item2, index2) => {return index2 < 3})" :item="item" :index="index" :key="index"></resolve-item>
      </div>
    </div>
    <foot-btm></foot-btm>
  </div>
</template>

<script>
import headTop from '@/components/layout/headTop'
import footBtm from '@/components/layout/footBtm'
import homeTitle from './homeTitle'
import resolveItem from './resolveItem'
const Mock = require('mockjs')
export default {
  name: 'resolve',
  components: {
    headTop,
    homeTitle,
    resolveItem,
    footBtm
  },
  data () {
    return {
      resolveList: []
    }
  },
  mounted () {
    this.getResolve()
  },
  methods: {
    getResolve () {
      this.resolveList = Mock.mock(require('@/mock/json/resolve')).resolveList
    }
  }
}
</script>

<style scoped lang="less">
.homeContainer{
  background: #fafafa;
  .topDiv{
    max-width: 1920px;
    margin: 0 auto;
    width: 100%;
    overflow: hidden;
    img{
      height: 280px;
      margin: 0 auto;
      display: block;
    }
  }
}
</style>
